import React, { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import Navbar from "../Navbar/Navbar";
import Video from "../video/Video";
import "./home.css";
import Card from "../card/Card";
import { Col, Container, Row } from "react-bootstrap";
import Footer from "../footer/Footer";
import Cartina from "../map/Cartina";
import Prenota from "./Prenota";
import { useLocation } from "react-router-dom";
import LanguageSelector from "../../Language/LanguageSelector";
import { useTranslation } from "react-i18next";

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  const sections = [
    { ref: useInView({ triggerOnce: true, threshold: 0.1 }), controls: useAnimation() },
    { ref: useInView({ triggerOnce: true, threshold: 0.1 }), controls: useAnimation() },
    { ref: useInView({ triggerOnce: true, threshold: 0.1 }), controls: useAnimation() },
    { ref: useInView({ triggerOnce: true, threshold: 0.1 }), controls: useAnimation() },
    { ref: useInView({ triggerOnce: true, threshold: 0.1 }), controls: useAnimation() },
    { ref: useInView({ triggerOnce: true, threshold: 0.1 }), controls: useAnimation() },
  ];

  useEffect(() => {
    sections.forEach((section) => {
      if (section.ref[1]) {
        section.controls.start("visible");
      }
    });
  }, [sections]);

  const variants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 1 } },
  };
  const { t } = useTranslation();
  return (
    <>
      <Navbar />
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
        <Video />
      </motion.div>
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
        <LanguageSelector />
        <div className="logo">
          <img src="/img/angelo.png" alt="Logo Angelo" id="logo" />
        </div>
        <h2 id="tradizione">{t("title")}</h2>
        <Container>
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
            <hr />
            <Row>
              <Col xs={12} md={12} lg={6} id="pastacol">
                <img src="./img/immagini/pasta.png" alt="Pasta" style={{ width: "80%" }} />
              </Col>
              <Col xs={12} md={12} lg={6} id="pastacol">
                <div className="primobox">
                  <h1 className="mb-4"> {t("title2")}</h1>
                  <p> {t("p2")}</p>
                </div>
              </Col>
            </Row>
          </motion.div>
          <motion.div ref={sections[0].ref[0]} initial="hidden" animate={sections[0].controls} variants={variants}>
            <hr />
            <div className="box3">
              <h1> {t("title3")}</h1>
              <br></br>
              <p>
                {t("paragrafo1")}
                {t("paragrafo2")}
                <br />
                <br></br>
                <i>"{t("paragrafo3")}"</i>
              </p>
            </div>
          </motion.div>
          <motion.div ref={sections[1].ref[0]} initial="hidden" animate={sections[1].controls} variants={variants}>
            <Card />
          </motion.div>
          <motion.div ref={sections[2].ref[0]} initial="hidden" animate={sections[2].controls} variants={variants}>
            <div className="box2">
              <h1> {t("title4")}</h1>
              <p id="attualmente">{t("p4")} </p>
            </div>
          </motion.div>
          <motion.div ref={sections[3].ref[0]} initial="hidden" animate={sections[3].controls} variants={variants}>
            <Container>
              <Row>
                <Col xs={12}>
                  <h2 id="terramare" style={{ textAlign: "center" }}>
                    {t("title5")}
                  </h2>
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={6} lg={6} id="collast">
                  <img
                    src="./img/immagini/fuoco1.png"
                    alt="Forno a legna"
                    id="immagine"
                    className="image-with-effects"
                  />
                </Col>
                <Col xs={12} md={6} lg={6} id="collast">
                  <img src="./img/immagini/1.png" alt="Forno a legna" id="immagine" className="image-with-effects" />
                </Col>
              </Row>
              <Row>
                <Col xs={12} id="fire">
                  <p id="pizzp">
                    <i>"{t("p5")}"</i>
                  </p>
                </Col>
              </Row>
            </Container>
          </motion.div>
          <motion.div ref={sections[4].ref[0]} initial="hidden" animate={sections[4].controls} variants={variants}>
            <br></br>
            <br></br>
            <br></br>
            <p style={{ textAlign: "center" }}>* * * * * * * * * *</p>
            <Container>
              <Row>
                <Col xs={12}>
                  <h2 id="terramare" style={{ textAlign: "center" }}>
                    {t("title6")}
                  </h2>
                </Col>
              </Row>
              <Row>
                <Col xs={12} md={6} lg={6} id="collast">
                  <img
                    src="./img/immagini/polpo.png"
                    alt="Forno a legna"
                    id="immagine"
                    className="image-with-effects"
                  />
                </Col>
                <Col xs={12} md={6} lg={6} id="collast">
                  <img
                    src="./img/immagini/salumi.png"
                    alt="Forno a legna"
                    id="immagine"
                    className="image-with-effects"
                  />
                </Col>
              </Row>
              <Row>
                <Col xs={12} id="fire">
                  <p id="pizzp">
                    <i>"{t("p6")}"</i>
                  </p>
                </Col>
              </Row>
            </Container>
          </motion.div>
          <motion.div ref={sections[5].ref[0]} initial="hidden" animate={sections[5].controls} variants={variants}>
            <Prenota />
          </motion.div>
        </Container>
      </motion.div>
      <Cartina />
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
        <div className="footer" id="end"></div>
        <Footer id="footer" />
      </motion.div>
    </>
  );
};

export default Home;
